module.exports = __webpack_public_path__ + "img/googlegke-black.270042cf.svg";